import { useMutation } from "@tanstack/react-query"
import { api } from "../../../lib/api/client"

interface UploadParams {
  ticketId: string
  file: File
}

export function useUploadSystemTicketAttachment() {
  return useMutation({
    mutationFn: ({ ticketId, file }: UploadParams) => {
      const formData = new FormData()
      formData.append("ticket_id", ticketId)
      formData.append("file", file)
      return api.systemTickets.upload(formData)
    },
  })
}
